<template>
    <div>
        <div class="listing_images">
            <div id="listing_images_slider" class="listing_images_slider">
                <div
                    v-for="(foto, i) in fotosArray"
                    :key="i"
                    @click="index = i"
                >
                    <img
                        :src="
                            'https://d16vbrqyk5474c.cloudfront.net/fit-in/1280x720/' +
                                foto
                        "
                        class="image"
                    />
                </div>
            </div>
            <div
                id="listing_images_slider_nav"
                class="listing_images_slider_nav"
            >
                <div
                    v-for="(foto, i) in fotosArray"
                    :key="i"
                    @click="index = i"
                >
                    <img
                        :src="
                            'https://d16vbrqyk5474c.cloudfront.net/fit-in/1280x720/' +
                                foto
                        "
                    />
                </div>
            </div>
        </div>
        <vue-gallery-slideshow
            :images="gallery(fotosArray)"
            :index="index"
            @close="index = null"
            class="vue-gallery"
        ></vue-gallery-slideshow>
    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import VueGallerySlideshow from "vue-gallery-slideshow";

export default {
    components: {
        VueGallerySlideshow
    },
    props: {
        fotos: Object
    },
    data() {
        return {
            fotosArray: [],
            index: null
        };
    },
    mounted() {
        // this.fotosArray = Object.values(this.fotos);

        this.fotosArray = Object.entries(this.fotos)
            .filter(
                ([key, value]) =>
                    key !== "foto_redes_1" && key !== "foto_redes_2"
            )
            .map(([key, value]) => value);
    },
    computed: {
        ...mapFields("fichaTecnica", ["fotos_modal"])
    },
    methods: {
        gallery(item) {
            var images = item.map(function(foto) {
                return (
                    "https://d16vbrqyk5474c.cloudfront.net/fit-in/1280x720/" +
                    foto
                );
            });
            return images;
        }
    }
};
</script>

<style lang="scss">
.image {
    background-size: cover;
    cursor: pointer;
    border-radius: 3px;
    border: 1px solid lightgray;
    object-fit: contain;
}

.vgs__container {
    left: 0 !important;
    right: 0 !important;
    height: 80vh !important;
    background-color: #0000 !important;
}

.vgs__gallery {
    bottom: -30px !important;
    left: 0rem !important;
    right: 0rem !important;
}
.vgs__gallery__container__img {
    width: 80px !important;
    height: 50px !important;
    margin-right: 5px !important;
    border-radius: 2px !important;
}
</style>
